// Leaderboard Configuration File
// Edit this file to change leaderboard settings

// Start date of the current leaderboard cycle (YYYY-MM-DD format)
export const CYCLE_START_DATE = '2025-03-01';

// Duration of each leaderboard cycle in days
export const CYCLE_DURATION_DAYS = 7;

// API endpoint for the leaderboard data
export const API_ENDPOINT = 'https://api.goated.com/user/affiliate/referral-leaderboard/CODMN6M';

// How often to cache the data in milliseconds (15 minutes)
export const CACHE_INTERVAL = 15 * 60 * 1000;

// Legacy prize configuration (for compatibility with previous leaderboards)
export const LEGACY_PRIZES = {
  1: 35, // first place: $35
  2: 20, // second place: $20
  3: 15, // third place: $15
  4: 5,  // 4th place: $5
  5: 5,  // 5th place: $5
  6: 5,  // 6th place: $5
  7: 5,  // 7th place: $5
  8: 5,  // 8th place: $5
  9: 5,  // 9th place: $5
  10: 5, // 10th place: $5
};

// Dynamic reward scaling system
export const REWARD_SCALING = [
  { wagered: 50000, reward: 47.50 },
  { wagered: 100000, reward: 95.00 },
  { wagered: 200000, reward: 190.00 },
  { wagered: 300000, reward: 285.00 },
  { wagered: 400000, reward: 380.00 },
  { wagered: 500000, reward: 475.00 },
  { wagered: 750000, reward: 712.50 },
  { wagered: 1000000, reward: 950.00 },
  { wagered: 1250000, reward: 1187.50 },
  { wagered: 1500000, reward: 1425.00 },
  { wagered: 1750000, reward: 1662.50 },
  { wagered: 2000000, reward: 1900.00 },
  { wagered: 2500000, reward: 2375.00 },
  { wagered: 3000000, reward: 2850.00 },
  { wagered: 3500000, reward: 3325.00 },
  { wagered: 4000000, reward: 3800.00 },
  { wagered: 4500000, reward: 4275.00 },
  { wagered: 5000000, reward: 4750.00 }
];

// Prize distribution percentages (how the prize pool is split among winners)
export const PRIZE_DISTRIBUTION = {
  1: 0.35, // 35% for 1st place
  2: 0.20, // 20% for 2nd place
  3: 0.15, // 15% for 3rd place
  4: 0.05, // 5% for 4th place
  5: 0.05, // 5% for 5th place
  6: 0.05, // 5% for 6th place
  7: 0.05, // 5% for 7th place
  8: 0.05, // 5% for 8th place
  9: 0.03, // 3% for 9th place
  10: 0.02, // 2% for 10th place
};

// Dynamic prize pool calculation (will be recalculated based on total wagered)
export const calculatePrizePool = (totalWagered: number): number => {
  for (let i = REWARD_SCALING.length - 1; i >= 0; i--) {
    if (totalWagered >= REWARD_SCALING[i].wagered) {
      return REWARD_SCALING[i].reward;
    }
  }
  return 0; // Default if below minimum threshold
};

// For backwards compatibility
export const PRIZES = LEGACY_PRIZES;
export const TOTAL_PRIZE_POOL = 4750; // Maximum possible prize pool